<script setup lang="ts">
const settings = useSettings()
</script>

<template>
  <aside class="pa-quote-page__sidebar">
    <div v-if="settings?.data.company_image?.url" class="pa-quote-page__sidebar-image">
      <PrismicImage :field="settings.data.company_image" />
    </div>

    <div class="pa-quote-page__sidebar-section">
      <h3 v-if="settings?.data.company_name" class="pa-quote-page__sidebar-company">
        {{ settings.data.company_name }}
      </h3>
      <div v-if="settings?.data.address" class="pa-quote-page__sidebar-address">
        <PrismicRichText :field="settings.data.address" />
      </div>
      <PrismicLink
          v-if="settings?.data.maps_link && ('url' in settings.data.maps_link)"
          :field="settings.data.maps_link"
          class="pa-quote-page__sidebar-maps"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 0 1 15 0Z" />
        </svg>
        <span>Routebeschrijving</span>
      </PrismicLink>
    </div>

    <div class="pa-quote-page__sidebar-section">
      <h4 class="pa-quote-page__sidebar-title">Contactgegevens</h4>
      <div v-if="settings?.data.phone" class="pa-quote-page__sidebar-contact">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
        </svg>
        <a :href="`tel:${settings.data.phone}`">{{ settings.data.phone }}</a>
      </div>
      <div v-if="settings?.data.email" class="pa-quote-page__sidebar-contact">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
        </svg>
        <a :href="`mailto:${settings.data.email}`">{{ settings.data.email }}</a>
      </div>
    </div>

    <div v-if="settings?.data.opening_hours?.length" class="pa-quote-page__sidebar-section">
      <h4 class="pa-quote-page__sidebar-title">Openingstijden</h4>
      <div
          v-for="(item, index) in settings.data.opening_hours"
          :key="index"
          class="pa-quote-page__sidebar-hours"
      >
        <span>{{ item.day }}</span>
        <span>{{ item.hours }}</span>
      </div>
    </div>

    <div v-if="settings?.data.postal_address" class="pa-quote-page__sidebar-section">
      <h4 class="pa-quote-page__sidebar-title">Postadres</h4>
      <div class="pa-quote-page__sidebar-address">
        <PrismicRichText :field="settings.data.postal_address" />
      </div>
    </div>
  </aside>
</template>
